import ReactDom from "react-dom";
import ManualEventsListingUpcoming from "./ManualEventsListingUpcoming.jsx";
import ManualEventsListingPast from "./ManualEventsListingPast.jsx";

export function renderManualEventsListingUpcoming() {
  document
    .querySelectorAll(".js-manual-events-listing-upcoming-carousel-mount")
    .forEach((mount, i) => {
      const dataModel = JSON.parse(mount.dataset.model);

      dataModel &&
        ReactDom.render(
          <ManualEventsListingUpcoming index={i} {...dataModel} />,
          mount,
        );
    });
}

export function renderManualEventsListingPast() {
  document
    .querySelectorAll(".js-manual-events-listing-past-carousel-mount")
    .forEach((mount, i) => {
      const dataModel = JSON.parse(mount.dataset.model);

      dataModel &&
        ReactDom.render(
          <ManualEventsListingPast index={i} {...dataModel} />,
          mount,
        );
    });
}
